import React from 'react';
import illustration from '../../Images/cyber-attack-pana.webp';
import { ReactTyped as Typed } from 'react-typed';

const HomeMain = ({ bgColor, titleOne, titleTwo, text, subTitle }) => {
  return (
    <div className={`flex justify-center items-center ${bgColor} text-white h-5/6`}>
      <div className="container items-center mx-auto px-4 md:px-44 mb-10 mt-32">
        <div className="flex flex-col md:flex-row items-center justify-center">
          <div className="md:w-1/2 text-center md:text-left md:mx-8">
            <h1 className="text-6xl md:text-6xl font-bold mt-0" style={{ fontFamily: 'Anonymous Pro, sans-serif' }}>
              {titleOne}
            </h1>
            <h1 className="text-6xl md:text-6xl font-bold mt-0" style={{ fontFamily: 'Anonymous Pro, sans-serif' }}>
              {titleTwo}
            </h1>
            <h2 className="text-4xl md:text-5xl font-bold md:mb-4 text-[#d11c9b]" style={{ fontFamily: 'Anonymous Pro, sans-serif' }}>
              <Typed
                strings={subTitle}
                typeSpeed={120}
                backSpeed={10}
                loop
              />
            </h2>
            <p className="mb-6 text-2xl" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              {text}
            </p>
            <a href="#contact" className="bg-[#d11c9b] text-black font-bold py-2 px-4 rounded-lg inline-block">
              BECOME BREACHLESS
            </a>
          </div>
          <div className="hidden md:flex md:w-1/2 items-center justify-center mt-8 md:mt-0">
            <img
              src={illustration}
              alt="Illustration"
              className="w-36 h-36 md:w-5/6 md:h-5/6"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeMain;
